import BookkeepingFilter from "components/filters/Filters/BookkeepingFilter";
import ContactFilter from "components/filters/Filters/ContactFilter";
import { DocumentSortFilter } from "components/filters/Filters/SortFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import React from "react";
import DocumentProgressFilter from "components/filters/Filters/DocumentProgressFilter";
import CompanyFilter from "components/filters/Filters/CompanyFilter";
import OnlyMySelectionFilter from "components/filters/Filters/OnlyMySelectionFilter";

interface Props {
  documentType: server.dto.DocumentTypes
  statuses: server.dto.StatusSmall[]
  hasStatuses: boolean
}

const Filters = (props: Props) => {
  return <>
    <KeywordFilter
      label={RESX.GeneralLabels.Number}
      title={RESX.Document.DocumentNumber}
      placeholder={RESX.Document.DocumentNumberPlaceHolder}
    />
    <CompanyFilter
      title={RESX.Document.Addressee}
    />
    <ContactFilter />
    <DocumentProgressFilter />
    <BookkeepingFilter />
    {props.hasStatuses && (
      <StatusFilter initialStatuses={props.statuses} />)}
    <OwnersFilter />
    <PeriodFilter targets={["sendDate", "dueDate"]} />
    <DocumentSortFilter documentType={props.documentType} />
    <OnlyMySelectionFilter />
  </>;
};

export default Filters;
